var ngModule;
try {
  ngModule = angular.module('templates');
} catch (e) {
  ngModule = angular.module('templates', []);
}

ngModule.run(['$templateCache', function ($templateCache) {
  $templateCache.put('/modals/slider/slider.html',
    '<div class="modal-body">\n' +
    '    <uib-carousel no-wrap="true" template-url="/modals/slider/carousel.html">\n' +
    '        <uib-slide ng-repeat="slide in slider.slides" active="slide.active">\n' +
    '            <div class="carousel-img-wrapper" ng-style="slide.style">\n' +
    '                <img class="responsive-img" ng-src="{{ slide.image_path }}">\n' +
    '            </div>\n' +
    '            <div class="modal-footer">\n' +
    '                <!-- <a href="#" class="btn-link modal-popup__edit">Редактировать описание</a> -->\n' +
    '                <p ng-if="slide.description">{{ slide.description }}</p>\n' +
    '            </div>\n' +
    '        </uib-slide>\n' +
    '    </uib-carousel>\n' +
    '</div>\n' +
    '<button class="close" ng-click="slider.close()"></button>');
}]);

module.exports = "/modals/slider/slider.html";